import React from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Firebase from "firebase";
import AddIcon from "@material-ui/icons/Add";
import DialogActions from "@material-ui/core/DialogActions";
import FavoritesButton from "../../Buttons/FavoritesButton";
import {useAuthState} from "react-firebase-hooks/auth";
import CloseButton from "../../Buttons/CloseButton";
import useFavorites from "../../../Context/Consumers/useFavorites";
import ItemType from "../../../Models/ItemType";
import toggleFavorite from "../../../Helper/toggleFavorite";
import triggerHaptics from "../../../Helper/triggerHaptics";

interface EventPageFooterProps {
    onClose: () => void;
    onAdd: () => void;
    id: string;

}

const ContentContainer = styled(Grid)`
  padding-left: 16px;
  padding-right: 16px;
`;

const EventPageFooter = (props: EventPageFooterProps) => {
    const {onClose, onAdd, id} = props;
    const [user] = useAuthState(Firebase.auth());

    const favorites: any = useFavorites();

    const onClickFavorite = () => {
        toggleFavorite(id, ItemType.Event, favorites, user.uid);
        triggerHaptics();
    };

    return (
        <DialogActions>
            <ContentContainer
                container
                justify={'space-between'}
                alignItems={'center'}
            >
                <Grid item>
                    <CloseButton title={"close"} onClose={onClose} />
                </Grid>
                <Grid item>
                    {user &&
                        <FavoritesButton
                            onClick={onClickFavorite}
                            selected={!!(favorites && favorites[ItemType.Event] && favorites[ItemType.Event][id])} />
                    }
                    <IconButton
                        edge={'end'}
                        onClick={onAdd}
                    >
                        <AddIcon />
                    </IconButton>
                </Grid>
            </ContentContainer>
        </DialogActions>
    );
}

export default EventPageFooter;